import $api from "@http";

const BASE = "/api/v1/doctor_profiles";

export default class DoctorsService {
  static async getDoctors({page, size, search, sort}) {
    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (size != null) params.append("page_size", size);
    if (search) params.append("q[name_cont]", search);
    if (sort?.value && sort?.direction) {
      params.append("q[s][]", `${sort.value} ${sort.direction}`);
    }

    return $api.get(`${BASE}?${params.toString()}`);
  }

  static async viewDoctor({id}) {
    return $api.get(`${BASE}/${id}`);
  }

  static async createDoctor({doctor}) {
    return $api.post(BASE, {doctor_profile: doctor});
  }
}
